/**
 * Created by FLI on 2015-02-12.
 */

angular.module('ffApp').controller('TVController', ['$scope', function($scope)
{
	$scope.playerOpen = function( clip_type, clip_id )
	{
		var player = $scope.getPlayer();

		if( clip_type == 'youtube' ) {
			$scope.insertYoutube( clip_id );
		}
		else {
			$scope.insertKanal5play( clip_id );
		}

		if( ! player.is(':visible') ) {
			player.show('blind');
		}

		//Scroll up
		var position = player.offset().top - 20;
		jQuery("html, body").animate({ scrollTop: position+"px", easing: 'easeOutQuint' });

	};

	$scope.playerClose = function()
	{
		var player = $scope.getPlayer();

		if( player.is(':visible') ) {
			player.hide('blind');
		}
	};

	$scope.insertYoutube = function( clip_id )
	{
		var player = $scope.getPlayer();
		var dim = $scope.playerDimensions();

		if( dim.w < 1030 ) {
			player.find('.holder').css('padding','0');
		}

		var html = '<iframe id="player-'+clip_id+'" type="text/html" width="'+dim.w+'" height="'+dim.h+'" \
		src="http://www.youtube.com/embed/'+clip_id+'?autoplay=1&origin=http://www.filipandfredrik.com" \
		frameborder="0"/>';

		player.find('.holder').html(html);
	};

	$scope.insertKanal5play = function( clip_id )
	{
		var player = $scope.getPlayer();
		var dim = $scope.playerDimensions();

		if( dim.w < 1030 ) {
			player.find('.holder').css('padding','0');
		}

		var html = '<iframe width="'+dim.w+'" height="'+dim.h+'" src="http://www.kanal5play.se/embed/'+clip_id+'?embedder=ff" frameborder="0" scrolling="no" allowfullscreen=""></iframe>';

		player.find('.holder').html(html);
	};

	$scope.getPlayer = function() {
		return jQuery('.page-viewport.tv').find('.tv-player');
	};

	$scope.playerDimensions = function() {
		var player = $scope.getPlayer();

		//Default dimensions
		var width = 1030;
		var height = 615;

		if( player.width() < 1030 )
		{
			var new_width = player.width();
			height = parseInt( new_width * 0.5625 );
			width = new_width;
			height += 36; //Bottom bar on player
		}

		return { w: width, h: height };
	}

}]);

